import { ecoAxios } from "./config/createAxiosInstance";

export const resinAPI = {
  getCharacterizedResin: async function (id, cancel = false) {
    const response = await ecoAxios.request({
      url: `/resin/recycled-characterized-resin`,
      method: "GET",
    });
    return response.data;
  },
  getVirginResin: async function (id, cancel = false) {
    const response = await ecoAxios.request({
      url: `/resin/virgin-characterized-resin`,
      method: "GET",
    });
    return response.data;
  },

  postEvaluationRequest: async function (payload) {
    const response = await ecoAxios.request({
      url: `/resin/evaluation-requests`,
      method: "POST",
      data: payload, // Your request body
    });
    return response.data;
  },
};
